module.exports = __webpack_public_path__ + "static/media/uv-stampa.f5187778.png";